<template>
  <section
    v-if="props.data"
    class="cardBlocks"
    :class="[ props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle: 'defaultStyle' ]"
  >
    <div
      class="container"
      :class="props.data.parentStyle === 'secondStyle' ? 'no-padding' : 'col'"
    >
      <div
        class="row"
        :class="props.data.parentStyle === 'secondStyle' ? 'justify-content-center' : ''"
      >
        <div
          v-if="props.data.title || props.data.descr"
          :class="props.data.parentStyle === 'secondStyle' ? '' : 'lg'"
          class="section-heading mb-4"
        >
          <h2
            v-if="props.data.title"
            :class="props.data.parentStyle === 'secondStyle' ? 'h3 title' : ''"
          >
            {{ props.data.title }}
          </h2>
          <div
            v-if="props.data.descr"
            v-html="convertToHtml(props.data.descr)"
          ></div>
        </div>

        <div class="row cardBlocks__items">
          <div
            v-for="item in props.data.items"
            :key="item"
            class="col cardBlocks__item"
            :class="item.classes"
          >
            <div class="card-holder">
              <div class="card">
                <div
                  v-if="item.image"
                  class="card-image"
                >
                  <nuxt-picture
                    preload
                    :img-attrs="{class: 'responsive-img', alt: item.title}"
                    :src="item.image"
                    :placeholder="[100, 50, 10]"
                    sizes=""
                    loading="lazy"
                  />
                </div>
                <div class="card-content">
                  <template v-if="item.title">
                    <h4
                      v-if="props.data.parentStyle === 'secondStyle'"
                      class="h4"
                    >
                      {{ item.title }}
                    </h4>

                    <span
                      v-else
                      class="card-title"
                    >{{ item.title }}</span>
                  </template>
                  <div class="text-wrapper">
                    <div
                      v-if="item.descr"
                      v-html="convertToHtml(item.descr)"
                    ></div>
                  </div>
                </div>
                <div
                  v-if="item.content"
                  class="subDescr"
                  :class="{ 'hideSub': props.data.hideSubDescr}"
                  v-html="convertToHtml(item.content)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.cardBlocks {
  &__items {
    width: 100%;
  }
  &__item {
    margin-bottom: 2rem;
  }
  .card {
    height: 100%;
    transition: all .3s ease;
    cursor: pointer;
    &-holder {
      position: relative;
      width: 100%;
      height: 100%;
      &:hover {
        @media only screen and (min-width: 993px) {
          .card {
            top: 0;
            left: 0;
            z-index: 2;
            width: 100%;
            transform: scale(1.05);
          }
          .subDescr {
            &.hideSub {
              display: block;
            }
          }
        }
      }
    }
    &-image {
      &:deep(img) {
        height: auto;
      }
    }

    &-content {
      padding: 2rem;
      border-radius: 0 0 2px 2px;

      @media only screen and (max-width: 992px) {
        padding: 1rem;
      }
      .text-wrapper {
        @media only screen and (min-width: 768px) {
          overflow: hidden;
          text-overflow: ellipsis;

          box-orient: vertical;
          line-clamp: 2;
        }
      }
    }

    &-title {
      font-size: 1rem;
      font-weight: 600;
    }

    &:deep(.card-list) {
      padding-top: 0;
      margin-top: 0;
      li {
        position: relative;
        padding-left: 25px;
        margin-bottom: 7px;
        color: #015287;
        font-size: 11px;
        font-weight: 600;
        line-height: 1.4;
        .icon {
          position: absolute;
          top: 50%;
          left: 0;
          color: #26c439;
          font-size: 1rem;
          transform: translateY(-50%);
        }
      }
    }
  }
  .subDescr {
    position: absolute;
    width: 100%;
    padding: 0 2rem 1rem 2rem;
    background: #fff;
    &.hideSub {
      display: none;
    }
  }

  // Second Style
  &.secondStyle {
    .card-holder {
      .card {
        background-color: transparent;
        box-shadow: none;
        &-image {
          position: relative;
          z-index: 1;
          overflow: hidden;
          width: 100%;
          height: 0;
          padding-bottom: 100%;
          margin: 0 auto;
          text-align: center;
          &:deep(img) {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            display: block;
            width: auto;
            width: 100%!important;
            max-width: 100%!important;
            height: auto!important;
            max-height: 100%;
            margin: 0 auto;

            -o-object-fit: contain;
               object-fit: contain;
          }
        }
        .h4 {
          display: block;
          margin: 1rem auto;
          font-weight: 400;
          text-align: center;
        }
      }

      &:hover {
        .card {
          transform: scale(1);
        }
      }
    }
    .card-content {
      padding: 0;
      border-radius: 0;
    }
  }
}
</style>
